<template>
  <div>
    <el-upload
    v-loading="isdisabled"
      :class="['upload-demo']"
      ref="upload"
      action="#"
      accept=".jpg,.jpeg,.png"
      :on-remove="handleRemoveFace"
      :on-change="handleSetUploadData"
      :on-preview="handlePictureCardPreview"
      :disabled="isdisabled"
      list-type="picture-card"
      :limit="1"
      :auto-upload="false"
      :file-list="fileListFace"
    >
      <div
        class="custom-upload"
        :class="{
          noAdd: fileListFace.length,
        }"
      >
        <i class="el-icon-plus"></i>
      </div>
      <el-dialog :visible.sync="dialogVisible" append-to-body>
        <img width="100%" height="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </el-upload>
  </div>
</template>
 
<script>
import axios from "axios";
import { getBasicUrls, getBaseUrl } from "@/util/config";
import LoginUserHelper from "@/util/LoginUserHelper";

export default {
  name: "faceUpload",
  model: {
    prop: "fileListFace",
    event: "change",
  },
  props: {
    fileListFace: {
      type: Array,
      default: () => [],
    },
    accountId: {
      type: [String, Number, null, undefined],
      required: true,
    },
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      serial_num: "",
      isdisabled: false,
    };
  },
  methods: {
    updateValue() {
      this.$emit("change", this.fileListFace);
    },
    /**
     * 重置上传状态
     * @description 清空文件列表并重置相关状态
     */
    resetUploadState() {
      this.fileListFace.shift();
      this.serial_num = "";
      this.updateValue();
    },
    /**
     * 处理上传错误
     * @param {string} message - 错误信息
     * @description 显示错误消息并重置状态
     */
    handleUploadError(message) {
      this.fileListFace.shift();
      this.$message.error(message);
      this.updateValue();
    },
    /**
     * 处理上传成功
     * @param {Object} item - 上传的文件对象
     * @param {string} serialNum - 服务器返回的序列号
     * @description 更新文件列表和相关状态
     */
    handleUploadSuccess(item, serialNum) {
      console.log("item :>> ", item);
      let BASE_URL = getBaseUrl();
      let FormDatas = new FormData();
      FormDatas.append("file", item.raw);
      axios
        .post(`${BASE_URL}base/upload/uploadPicture?type=record`, FormDatas, {
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: LoginUserHelper.getUserToken(),
          },
        })
        .then((res) => {
          console.log("res", res);
          if (res.code == 0) {
            console.log("res.data", res.data);
            let { fileName, uploadPath } = res.data;
            this.fileListFace.push({
              name: fileName,
              url: uploadPath,
            });
            this.serial_num = serialNum || "";
            this.updateValue();
            this.$message.success(this.$t('app.uploadSuccess'));
          } else {
            this.$message.error(this.$getCodeMessage(res.code, res.message, res.messageArgs));
          }
        })
        .finally(() => {
          this.isdisabled = false;
        });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    /**
     * 上传图片并进行人脸检测
     */
    async handleSetUploadData(item) {
        this.$refs.upload.clearFiles();
      if (!this.accountId) {
        this.$message.error(this.$t('salesCenter.pleaseEnterStudentAccountFirst'));
        this.$refs.upload.clearFiles();
        return false;
      }
      this.isdisabled = true;

      // 获取原始文件对象
      const file = item.raw;

      // 校验文件格式 - 仅允许JPG/JPEG/PNG
      const isValidFormat = ["image/jpeg","image/jpg", "image/png"].includes(file.type);
      if (!isValidFormat) {
        this.$message.error(this.$t('salesCenter.imageFormatJpgJpegPng'));
        this.$refs.upload.clearFiles();
        this.isdisabled = false;
        return false;
      }

      // 校验文件大小 - 限制1MB
      const isValidSize = file.size / 1024 / 1024 < 1;
      if (!isValidSize) {
        this.$refs.upload.clearFiles();
        this.$message.warning(this.$t('salesCenter.fileSizeExceed1MB'));
        this.isdisabled = false;
        return false;
      }

      // 准备FormData用于文件上传
      const formData = new FormData();
      formData.append("file", file);
      formData.append("accountId", this.accountId);

      try {
        // 发送人脸检测请求到服务器
        const schoolm = getBasicUrls().schoolm;
        const res = await axios.post(
          `${schoolm}manage/agent/accountUserFaceInfoDetectAll`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              authorization: LoginUserHelper.getUserToken(),
            },
          }
        );

        // 解构响应数据
        const { code, data = {}, message } = res;
        const { serial_num, face_info = {}, face_exist } = data || {};
        const { age } = face_info || {};

        if (code === 0) {
          this.handleUploadSuccess(item, serial_num);
        } else {
          this.handleUploadError(message);
          this.isdisabled = false;
        }
      } catch (err) {
        // 处理请求异常
        this.$message.error(this.$t('app.uploadFail'));
        this.resetUploadState();
        this.isdisabled = false;
      }
    },
    // 删除图片
    handleRemoveFace(file) {
      this.fileListFace.shift();
      this.updateValue();
    },
  },
  mounted() {
    console.log("this.fileListFace :>> ", this.fileListFace);
  },
};
</script>
 
<style lang='scss'  scoped>
::v-deep .el-upload {
  &:has(.noAdd) {
    display: none;
  }
}
</style>
